export interface Competency {
  title: string
  detail: string
}

export const competencies: Competency[] = [
  {
    title: 'Capital & Liquidity',
    detail:
      'Capital allocation, liquidity management, and financial restructuring.',
  },
  {
    title: 'Risk & Compliance',
    detail:
      'Enterprise risk assessment, cyber oversight, and regulatory compliance.',
  },
  {
    title: 'M&A & Growth',
    detail:
      'Strategic M&A evaluation, integration execution, and venture scale.',
  },
  {
    title: 'Leadership & Board Counsel',
    detail:
      'Executive talent development, succession planning, and board communication.',
  },
]

export interface ImpactMetric {
  value: string
  title: string
  detail: string
}

export const impactMetrics: ImpactMetric[] = [
  {
    value: '$500M+',
    title: 'Capital Allocation',
    detail:
      'Managed multivariant portfolios totaling $500M+ in enterprise value with high yield returns.',
  },
  {
    value: '35%',
    title: 'Revenue Growth',
    detail:
      'Championed organic and strategic M&A initiatives generating 35% compound annual growth.',
  },
  {
    value: '$20M+',
    title: 'Operational Efficiency',
    detail:
      'Optimized enterprise cost structures, unlocking $20M+ in recurring annual savings across business units.',
  },
]

export interface ValuePillar {
  label: string
  statement: string
}

export const valuePillars: ValuePillar[] = [
  {
    label: 'Governance Focus',
    statement:
      'Strengthening audit oversight, ESG alignment, and committee leadership structures.',
  },
  {
    label: 'Value Creation',
    statement:
      'Translating complex market disruptions into actionable, long-term corporate roadmaps.',
  },
  {
    label: 'Stakeholder Alignment',
    statement:
      'Balancing shareholder returns with sustainable, multi-stakeholder growth models.',
  },
]

export interface SystemsArea {
  title: string
  detail: string
}

export const systemsPortfolio: SystemsArea[] = [
  {
    title: 'Data Governance & Analytics',
    detail:
      'Overseeing enterprise BI platforms, predictive data models, and executive reporting tools.',
  },
  {
    title: 'Enterprise Infrastructure',
    detail:
      'Steering legacy system modernizations, cloud migrations, and ERP implementations.',
  },
  {
    title: 'Cybersecurity & Risk Infrastructure',
    detail:
      'Implementation of robust cybersecurity frameworks and corporate data protection strategies.',
  },
]
